import moment from 'moment'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'

export default function CommunicationPanel({
	communications = [],
	newNote,
	setNewNote,
	addingNote = false,
	onAddNote
}) {
	// Use the backend-provided ordering directly; ensure we have an array
	const items = Array.isArray(communications) ? communications : []

	const canAdd = Boolean(newNote?.trim()) && !addingNote

	return (
		<div className="flex h-full max-h-[600px] w-full flex-col rounded-xl bg-white shadow-sm">
			{/* Header */}
			<div className="border-b border-gray-300 bg-gray-100 px-6 py-3">
				<div className="flex items-start gap-3 text-gray-700">
					<h2 className="flex items-center gap-2 text-md font-semibold text-gray-900">
						<ChatBubbleLeftRightIcon className="h-5 w-5 text-sky-700" />
						<span>Communication history</span>
					</h2>
				</div>
			</div>

			<div className="flex-1 overflow-y-auto px-3 py-3 sm:px-4 mr-4 sm:mr-2">
				{/* Add Note Section */}
				<div className="bg-white p-2">
					<div className="space-y-3">
						<textarea
							value={newNote}
							onChange={e => setNewNote?.(e.target.value)}
							rows={2}
							className="block w-full resize-none rounded-xl border border-gray-200 bg-white px-3.5 py-3 text-sm text-gray-900 shadow-inner placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-70"
							placeholder="Add a new note about communication with this lead..."
						/>
						<div className="grid grid-cols-1 gap-3">
							<button
								type="button"
								onClick={onAddNote}
								disabled={!canAdd}
								className="inline-flex items-center justify-center rounded-xl px-4 py-3 text-sm font-semibold shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
								{addingNote ? 'Adding...' : 'Add Note'}
							</button>
						</div>
					</div>
				</div>

				{/* Communications List */}
				<div className="mt-4 mb-4 space-y-4">
					{items.length > 0 ? (
						<div className="relative space-y-5">
							<div className="absolute left-5 top-0 h-full w-px bg-gray-200" aria-hidden="true" />
							{items.map((c, idx) => {
								const key = c._id || `${c.added ?? 'na'}-${idx}`
								return (
									<div key={key} className="relative flex items-start gap-4 pl-12">
										<div className="absolute left-1 top-3 flex h-8 w-8 items-center justify-center rounded-full border border-gray-200 bg-white text-blue-600 shadow-sm">
											<ChatBubbleLeftRightIcon className="h-5 w-5" />
										</div>
										<div className="w-full rounded-2xl border border-gray-200 bg-white pl-4 pr-4 pt-3 pb-3 shadow-sm">
											<p className="text-sm font-semibold text-gray-900">{moment(c?.added).format('YYYY-MM-DD HH:mm')} by {c?.userName || 'Unknown'}</p>
											<p className="mt-1 text-sm leading-relaxed text-gray-700 whitespace-pre-wrap">{c?.note ?? ''}</p>
										</div>
									</div>
								)
							})}
						</div>
					) : (
						<div className="flex min-h-[155px] items-center justify-center gap-3 rounded-md bg-white px-4 pt-5 text-sm text-slate-600">
							<ChatBubbleLeftRightIcon className="h-5 w-5 text-slate-400" />
							<span>No communication history.</span>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
